import { render, staticRenderFns } from "./user-profile.vue?vue&type=template&id=4329b5be"
import script from "./user-profile.vue?vue&type=script&lang=js"
export * from "./user-profile.vue?vue&type=script&lang=js"
import style0 from "./user-profile.vue?vue&type=style&index=0&id=4329b5be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports